// src/components/layouts/app/header/desktop/DesktopHeader.tsx
import React, { useState, useEffect } from 'react';
import { TopBar } from './TopBar';
import { BottomBar } from './BottomBar';

interface DesktopHeaderProps {
  onCartClick: () => void;
  onFavoritesClick: () => void;
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({ onCartClick, onFavoritesClick }) => {
  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`
      fixed top-0 left-0 right-0 z-50 w-full bg-white transition-shadow duration-300
      ${isScrolled ? 'shadow-lg' : 'shadow-md'}
    `}>
      <TopBar
        onCartClick={onCartClick}
        onFavoritesClick={onFavoritesClick}
        cartItemCount={2}
        favItemCount={1}
      />
      <BottomBar
        onMegaMenuToggle={setIsMegaMenuOpen}
        isMegaMenuOpen={isMegaMenuOpen}
      />
    </div>
  );
};